import { type FC, useState, useEffect } from "react";

import { Loader2 } from "lucide-react";

import { useProcessingChecklist } from "@/shared/hooks/useProcessingChecklist";
import { ProcessingChecklist } from "@/shared/components/ProcessingChecklist";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

const CHECKLIST_ITEMS = [
  "Reviewing your answers",
  "Matching court requirements",
  "Preparing your forms packet",
] as const;

export const AdminFormsLoadingScreen: FC<FlowCustomComponentProps> = ({ onComplete }) => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDone(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const { activeIndex, isDone } = useProcessingChecklist({
    itemCount: CHECKLIST_ITEMS.length,
    isTerminal: done,
    failed: false,
    onComplete: () => onComplete(),
  });

  return (
    <div className="flex flex-1 flex-col items-center justify-center text-center -mt-8 min-h-[60vh]">
      <Loader2 className="size-12 animate-spin text-brand" />

      <h4 className="mt-6">Finishing your forms packet</h4>

      <ProcessingChecklist
        items={CHECKLIST_ITEMS}
        activeIndex={activeIndex}
        isDone={isDone}
      />
    </div>
  );
};
